<template>
  <div>
    <div class="flex-container">
      <div class="row" style="margin: 10px">
        <el-tabs v-model="activeName">
          <el-tab-pane label="阶段时间安排" name="1">
            <div>
              <el-form
                ref="queryFormTime"
                :model="listQueryTime"
                :inline="true"
                label-width="110px"
              >
                <el-form-item prop="ktsx1">
                  <el-select
                    ref="ktsx1"
                    v-model="listQueryTime.ktsx"
                    placeholder="课题属性"
                    filterable
                    size="small"
                    style="width: 120px"
                    class="filter-item"
                    @change="handleChange1"
                  >
                    <el-option
                      v-for="item in ktsxOptions"
                      :key="item.dictValue"
                      :label="item.dictLabel"
                      :value="item.dictValue"
                    />
                  </el-select>
                </el-form-item>
                <span
                  v-if="user.courseAdmin == 1"
                  style="margin-top: 4px; display: inline-block"
                >
                  <el-button
                    type="primary"
                    icon="el-icon-plus"
                    size="small"
                    @click="addDialogTime = true"
                    style="margin-left: 15px"
                    >新增</el-button
                  >
                </span>
              </el-form>
            </div>
            <div>
              <el-table
                :data="stepTimeList"
                fit
                highlight-current-row
                tooltip-effect="dark"
                :max-height="height"
              >
                <el-table-column
                  v-if="user.courseAdmin == 1"
                  label="操作"
                  align="center"
                  min-width="100px"
                  class-name="small-padding fixed-width"
                >
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="text"
                      @click="handleEditTime(scope.row)"
                      >编辑</el-button
                    >
                    <el-button
                      size="mini"
                      type="text"
                      @click="handleDeleteTime(scope.row)"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  label="课题阶段名称"
                  prop="name"
                  min-width="110px"
                  align="left"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.name }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="课题属性"
                  prop="ktsx"
                  min-width="100px"
                  align="left"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.ktsx }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="开始时间"
                  prop="qsrq"
                  :show-overflow-tooltip="true"
                  min-width="100px"
                  align="left"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.qsrq }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="结束时间"
                  prop="jsrq"
                  min-width="100px"
                  align="left"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.jsrq }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="负责人"
                  prop="fzr"
                  min-width="100px"
                  align="left"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.fzr }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="关键物"
                  prop="words"
                  min-width="220px"
                  align="left"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.words }}</span>
                  </template>
                </el-table-column>
                <template slot="empty">
                  <div class="nodata">
                    <img src="@/img/nodata.png" alt="" width="160" />
                    <div>暂无数据</div>
                  </div>
                </template>
              </el-table>
              <el-pagination
                @size-change="handleSizeChangeStepTime"
                @current-change="handleCurrentChangeStepTime"
                :current-page="listQueryTime.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="listQueryTime.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="listQueryTime.total"
              ></el-pagination>
              <el-dialog
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                title="阶段时间安排新增"
                :visible.sync="addDialogTime"
                width="90%"
                v-if="addDialogTime"
              >
                <timeAdd ref="timeAdd" @giveFather="getSonTime"></timeAdd>
                <div slot="footer" class="dialog-footer">
                  <el-button type="primary" @click="handleSaveAddTime"
                    >确定</el-button
                  >
                  <el-button @click="addDialogTime = false">取消</el-button>
                </div>
              </el-dialog>
              <el-dialog
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                title="阶段时间安排编辑"
                :visible.sync="editDialogTime"
                width="90%"
                v-if="editDialogTime"
              >
                <timeEdit
                  ref="timeEdit"
                  :mxParams="mxParams"
                  @giveFather="getSonTime"
                ></timeEdit>
                <div slot="footer" class="dialog-footer">
                  <el-button type="primary" @click="handleSaveEditTime"
                    >确定</el-button
                  >
                  <el-button @click="editDialogTime = false">取消</el-button>
                </div>
              </el-dialog>
            </div>
          </el-tab-pane>
          <el-tab-pane v-if="user.courseAdmin == 1" label="评审安排" name="2">
            <div>
              <el-form
                ref="queryFormArrange"
                :model="listQueryArrange"
                :inline="true"
                label-width="110px"
              >
                <el-form-item prop="nf2">
                  <el-select
                    ref="nf2"
                    v-model="listQueryArrange.nf"
                    placeholder="年份"
                    filterable
                    size="small"
                    style="width: 100px"
                    class="filter-item"
                    @change="handleChange2"
                  >
                    <el-option
                      v-for="item in nfOptions"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>

                <el-form-item prop="ktsx2">
                  <el-select
                    ref="ktsx2"
                    v-model="listQueryArrange.ktsx"
                    placeholder="课题属性"
                    filterable
                    size="small"
                    style="width: 100px"
                    class="filter-item"
                    @change="handleChangeSsjd"
                  >
                    <el-option
                      v-for="item in ktsxOptions"
                      :key="item.dictValue"
                      :label="item.dictLabel"
                      :value="item.dictValue"
                    />
                  </el-select>
                </el-form-item>

                <el-form-item prop="ssjd">
                  <el-select
                    ref="ssjd"
                    v-model="listQueryArrange.ssjd"
                    placeholder="所属阶段"
                    filterable
                    size="small"
                    style="width: 100px"
                    class="filter-item"
                    @change="handleChange2(true)"
                  >
                    <el-option
                      v-for="item in sxjdOptions"
                      :key="item.dictValue"
                      :label="item.dictLabel"
                      :value="item.dictValue"
                    />
                  </el-select>
                </el-form-item>

                <span style="margin-top: 4px; display: inline-block">
                  <el-button
                    type="primary"
                    icon="el-icon-plus"
                    size="small"
                    @click="handleArrangeAdd()"
                    style="margin-left: 15px"
                    >按评委安排</el-button
                  >
                  <el-button
                    type="primary"
                    icon="el-icon-download"
                    size="small"
                    @click="handleExport"
                    style="
                      margin-left: 15px;
                      color: #fff;
                      background-color: #f8ac59;
                      border-color: #f8ac59;
                    "
                    >导出</el-button
                  >
                </span>
              </el-form>
            </div>
            <div>
              <el-table
                :data="arrangeList"
                fit
                highlight-current-row
                tooltip-effect="dark"
                :max-height="height"
              >
                <el-table-column
                  fixed
                  label="操作"
                  align="center"
                  min-width="90px"
                  class-name="small-padding fixed-width"
                >
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="text"
                      @click="handleEditArrange(scope.row)"
                      >编辑</el-button
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  fixed
                  label="课题编号"
                  prop="ktbh"
                  min-width="110px"
                  align="left"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.ktbh }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  fixed
                  label="课题名称"
                  prop="name"
                  min-width="250px"
                  align="left"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.name }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="负责人"
                  prop="fzr"
                  :show-overflow-tooltip="true"
                  min-width="80px"
                  align="left"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.fzr }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="课题属性"
                  prop="ktsx"
                  min-width="80px"
                  align="left"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.ktsx }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="课题阶段"
                  prop="ssjd"
                  min-width="80px"
                  align="left"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.ssjd }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="评审委员"
                  prop="pswy"
                  min-width="160px"
                  align="left"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.pswy }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="开始时间"
                  prop="qsrq"
                  min-width="170px"
                  align="left"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.qsrq }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="结束时间"
                  prop="jsrq"
                  min-width="170px"
                  align="left"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.jsrq }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="课题安排"
                  prop="psap"
                  min-width="80px"
                  align="left"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.psap }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="会议纪要员"
                  prop="hyjyy"
                  min-width="90px"
                  align="left"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.hyjyy }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="方式"
                  prop="psfs"
                  min-width="80px"
                  align="left"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.psfs }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="关键物"
                  prop="words"
                  min-width="200px"
                  align="left"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.words }}</span>
                  </template>
                </el-table-column>
                <template slot="empty">
                  <div class="nodata">
                    <img src="@/img/nodata.png" alt="" width="160" />
                    <div>暂无数据</div>
                  </div>
                </template>
              </el-table>
              <el-pagination
                @size-change="handleSizeChangeArrange"
                @current-change="handleCurrentChangeArrange"
                :current-page="listQueryArrange.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="listQueryArrange.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="listQueryArrange.total"
              ></el-pagination>
              <el-dialog
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                title="课题评委分配"
                :visible.sync="addDialogArrange"
                width="90%"
                v-if="addDialogArrange"
              >
                <arrangeAdd
                  ref="arrangeAdd"
                  :mxParams="mxParams"
                  @giveFather="getSonArrange"
                ></arrangeAdd>
                <div slot="footer" class="dialog-footer">
                  <el-button type="primary" @click="handleSaveAddArrange"
                    >确定</el-button
                  >
                  <el-button @click="addDialogArrange = false">取消</el-button>
                </div>
              </el-dialog>
              <el-dialog
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                :title="arrangeTitle"
                :visible.sync="editDialogArrange"
                width="90%"
                v-if="editDialogArrange"
              >
                <arrangeEdit
                  ref="arrangeEdit"
                  :mxParams="mxParams"
                  @giveFather="getSonArrange"
                ></arrangeEdit>
                <div slot="footer" class="dialog-footer">
                  <el-button type="primary" @click="handleSaveEditArrange"
                    >确定</el-button
                  >
                  <el-button @click="editDialogArrange = false">取消</el-button>
                </div>
              </el-dialog>
            </div>
          </el-tab-pane>
          <el-tab-pane v-if="user.courseAdmin == 1" label="课题分享" name="3">
            <div>
              <el-form
                ref="queryFormShare"
                :model="listQueryShare"
                :inline="true"
                label-width="110px"
              >
                <el-form-item prop="nf3">
                  <el-select
                    ref="nf3"
                    v-model="listQueryShare.nf"
                    placeholder="年份"
                    filterable
                    size="small"
                    style="width: 100px"
                    class="filter-item"
                    @change="handleChange3"
                  >
                    <el-option
                      v-for="item in nfOptions"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>

                <el-form-item prop="ktsx3">
                  <el-select
                    ref="ktsx3"
                    v-model="listQueryShare.ktsx"
                    placeholder="课题属性"
                    filterable
                    size="small"
                    style="width: 100px"
                    class="filter-item"
                    @change="handleChange3"
                  >
                    <el-option
                      v-for="item in ktsxOptions"
                      :key="item.dictValue"
                      :label="item.dictLabel"
                      :value="item.dictValue"
                    />
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
            <div>
              <el-table
                :data="shareList"
                fit
                highlight-current-row
                tooltip-effect="dark"
                :max-height="height"
              >
                <el-table-column
                  fixed
                  label="操作"
                  align="center"
                  min-width="90px"
                  class-name="small-padding fixed-width"
                >
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="text"
                      @click="handleEditShare(scope.row)"
                      >编辑</el-button
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  fixed
                  label="课题编号"
                  prop="ktbh"
                  min-width="110px"
                  align="left"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.ktbh }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  fixed
                  label="课题名称"
                  prop="name"
                  min-width="250px"
                  align="left"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.name }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="负责人"
                  prop="fzr"
                  :show-overflow-tooltip="true"
                  min-width="80px"
                  align="left"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.fzr }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="课题属性"
                  prop="ktsx"
                  min-width="80px"
                  align="left"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.ktsx }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="是否确认结项"
                  prop="sfjx"
                  min-width="105px"
                  align="left"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.sfjx }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="开始时间"
                  prop="qsrq"
                  min-width="170px"
                  align="left"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.qsrq }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="结束时间"
                  prop="jsrq"
                  min-width="170px"
                  align="left"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.jsrq }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="讲师"
                  prop="fsds"
                  min-width="80px"
                  align="left"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.fsds }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="完成情况"
                  prop="sfwc"
                  min-width="80px"
                  align="left"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.sfwc }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="获奖情况"
                  prop="jxmc"
                  min-width="80px"
                  align="left"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.jxmc }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="奖项报销"
                  prop="fsbx"
                  min-width="80px"
                  align="left"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.fsbx }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="备注"
                  prop="bz"
                  min-width="100px"
                  align="left"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.bz }}</span>
                  </template>
                </el-table-column>
                <template slot="empty">
                  <div class="nodata">
                    <img src="@/img/nodata.png" alt="" width="160" />
                    <div>暂无数据</div>
                  </div>
                </template>
              </el-table>
              <el-pagination
                @size-change="handleSizeChangeShare"
                @current-change="handleCurrentChangeShare"
                :current-page="listQueryShare.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="listQueryShare.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="listQueryShare.total"
              ></el-pagination>
              <el-dialog
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                :title="shareTitle"
                :visible.sync="editDialogShare"
                width="90%"
                v-if="editDialogShare"
              >
                <shareEdit
                  ref="shareEdit"
                  :mxParams="mxParams"
                  @giveFather="getSonShare"
                ></shareEdit>
                <div slot="footer" class="dialog-footer">
                  <el-button type="primary" @click="handleSaveEditShare"
                    >确定</el-button
                  >
                  <el-button @click="editDialogShare = false">取消</el-button>
                </div>
              </el-dialog>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { formatMomentDate } from "@/utils/utils";
import moment from "moment";
import "moment/locale/zh-cn";
import { mapGetters } from "vuex";
import { getDictData } from "@/api/task.js";
import {
  getCourseQueryCondition,
  stepTimeList,
  arrangeList,
  shareList,
  stepTimeDel,
  arrangeExport,
} from "@/api/course.js";
import timeAdd from "./timeAdd.vue";
import timeEdit from "./timeEdit.vue";
import arrangeAdd from "./arrangeAdd.vue";
import arrangeEdit from "./arrangeEdit.vue";
import shareEdit from "./shareEdit.vue";

export default {
  name: "courseArrange",
  computed: {
    ...mapGetters(["user"]),
  },
  components: { timeAdd, timeEdit, arrangeAdd, arrangeEdit, shareEdit },
  data() {
    return {
      activeName: "1",
      height: 500,
      listQueryTime: {
        ktsx: "1",
        page: 1,
        pageSize: 50,
        total: 0,
      },
      listQueryArrange: {
        ktsx: "1",
        nf: "",
        ssjd: "3",
        page: 1,
        pageSize: 50,
        total: 0,
      },
      listQueryShare: {
        ktsx: "1",
        nf: "",
        page: 1,
        pageSize: 50,
        total: 0,
      },
      ktsxOptions: [],
      nfOptions: [],
      sxjdOptions: [],
      sxjdOptionsYj: [],
      sxjdOptionsJs: [],
      sxjdOptionsYn: [],
      stepTimeList: [],
      arrangeList: [],
      shareList: [],

      addDialogTime: false,
      editDialogTime: false,

      addDialogArrange: false,
      editDialogArrange: false,
      arrangeTitle: "阶段评委安排编辑",

      addDialogShare: false,
      editDialogShare: false,
      shareTitle: "课题分享",

      mxParamsTime: {},
    };
  },

  created() {
    this.listQueryArrange.nf = new Date().getFullYear();
    this.listQueryShare.nf = new Date().getFullYear();
    const docH = document.documentElement.clientHeight;
    // const mycontainerH = document.querySelector(".flex-container").clientHeight;
    // this.defaulContainerH = mycontainerH;
    this.height = docH - 270;
    if (this.$route.params.ktsx) {
      this.listQueryTime.ktsx = this.$route.params.ktsx + "";
    }
    //课题属性
    getDictData("pmp_course_group", 1).then((res) => {
      if (res.code === 0) {
        this.ktsxOptions = res.data;
      }
    });
    //年份
    getCourseQueryCondition({ type: 5 }).then((res) => {
      if (res.code === 0) {
        this.nfOptions = res.data;
      }
    });
    //所属阶段
    getDictData("pmp_course_step", 1).then((res) => {
      if (res.code === 0) {
        this.sxjdOptions = res.data.filter(
          (ele) =>
            ele.dictLabel.indexOf("审") != -1 ||
            ele.dictLabel.indexOf("质量评分") != -1
        );
        for (let i of this.sxjdOptions) {
          if (i.dictValue != 15 && i.dictValue != 16) {
            this.sxjdOptionsYj.push(i);
          }
          if (i.dictValue != 16) {
            this.sxjdOptionsJs.push(i);
          }
          if (i.dictValue != 15) {
            this.sxjdOptionsYn.push(i);
          }
          this.sxjdOptions = this.sxjdOptionsYj;
        }
      }
    });
    this.getStepTimeList();
    this.getArrangeList();
    this.getShareList();
  },
  mounted() {},
  methods: {
    handleChange1() {
      this.getStepTimeList();
    },
    handleSizeChangeStepTime(val) {
      this.listQueryTime.pageSize = val;
      this.getStepTimeList();
    },
    handleCurrentChangeStepTime(val) {
      this.listQueryTime.page = val;
      this.getStepTimeList();
    },
    getStepTimeList() {
      const params = { ...this.listQueryTime };
      stepTimeList(params).then((res) => {
        this.loading = false;
        if (res.code == 0) {
          this.stepTimeList = res.data;
          this.listQueryTime.total = res.count;
        }
      });
    },
    handleChangeSsjd(e) {
      if (e == 1) {
        this.sxjdOptions = this.sxjdOptionsYj;
      } else if (e == 2) {
        this.sxjdOptions = this.sxjdOptionsJs;
      } else if (e == 3) {
        this.sxjdOptions = this.sxjdOptionsYn;
      }
      this.getArrangeList();
    },
    handleChange2() {
      this.getArrangeList();
    },
    handleSizeChangeArrange(val) {
      this.listQueryArrange.pageSize = val;
      this.getArrangeList();
    },
    handleCurrentChangeArrange(val) {
      this.listQueryArrange.page = val;
      this.getArrangeList();
    },
    getArrangeList() {
      const params = { ...this.listQueryArrange };
      arrangeList(params).then((res) => {
        this.loading = false;
        if (res.code == 0) {
          this.arrangeList = res.data;
          this.listQueryArrange.total = res.count;
        }
      });
    },

    handleChange3() {
      this.getShareList();
    },
    handleSizeChangeShare(val) {
      this.listQueryShare.pageSize = val;
      this.getShareList();
    },
    handleCurrentChangeShare(val) {
      this.listQueryShare.page = val;
      this.getShareList();
    },
    getShareList() {
      const params = { ...this.listQueryShare };
      shareList(params).then((res) => {
        this.loading = false;
        if (res.code == 0) {
          this.shareList = res.data;
          this.listQueryShare.total = res.count;
        }
      });
    },

    handleSaveAddTime() {
      this.$refs.timeAdd.handleAdd();
      // setTimeout(() => {
      //   this.getStepTimeList();
      // }, 500);
    },
    handleSaveEditTime() {
      this.$refs.timeEdit.handleEdit();
      // setTimeout(() => {
      //   this.getStepTimeList();
      // }, 500);
    },
    handleEditTime(row) {
      this.editDialogTime = true;
      this.mxParams = row;
    },
    handleDeleteTime(row) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          const params = { id: row.id };
          return stepTimeDel(params);
        })
        .then((res) => {
          if (res.code == 0) {
            this.getStepTimeList();
            this.$notify({
              title: "成功",
              message: "删除成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$notify({
              title: "失败",
              message: res.msg,
              type: "error",
              duration: 2000,
            });
          }
        })
        .catch(() => {});
    },
    getSonTime(dialog) {
      this.addDialogTime = dialog;
      this.editDialogTime = dialog;
      this.getStepTimeList();
    },
    handleArrangeAdd() {
      this.mxParams = {
        ktsx: this.listQueryArrange.ktsx,
        ssjd: this.listQueryArrange.ssjd,
        nf: this.listQueryArrange.nf,
      };
      this.addDialogArrange = true;
    },
    handleSaveAddArrange() {
      this.$refs.arrangeAdd.handleAdd();
      // setTimeout(() => {
      //   this.getArrangeList();
      // }, 500);
    },
    handleEditArrange(row) {
      this.editDialogArrange = true;
      this.arrangeTitle = "【" + row.ktbh + "】" + row.name + ">编辑";
      this.mxParams = row;
    },
    getSonArrange(dialog) {
      this.addDialogArrange = dialog;
      this.editDialogArrange = dialog;
      this.getArrangeList();
    },
    handleSaveEditArrange() {
      this.$refs.arrangeEdit.handleAdd();
      // setTimeout(() => {
      //   this.getArrangeList();
      // }, 500);
    },
    handleEditShare(row) {
      this.editDialogShare = true;
      this.ShareTitle = row.name;
      this.mxParams = row;
    },
    getSonShare(dialog) {
      this.addDialogShare = dialog;
      this.editDialogShare = dialog;
      this.getShareList();
    },
    handleSaveEditShare() {
      this.$refs.shareEdit.handleAdd();
      // setTimeout(() => {
      //   this.getShareList();
      // }, 500);
    },
    handleExport() {
      const params = { ...this.listQueryArrange };
      arrangeExport(params).then((res) => {
        if (res.code === 0) {
          const fileName = res.msg.substr(
            res.msg.indexOf("_") + 1,
            res.msg.length
          );
          const filePath = res.msg;
          const url =
            window.g.apiUrl +
            "system/downloadFile?fileName=" +
            fileName +
            "&filePath=" +
            filePath;
          // 组装a标签
          const elink = document.createElement("a");
          // 设置下载文件名
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = url;
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "error",
          });
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.flex-container {
  width: 100%;
  height: 100%;
}
::v-deep .flex-container .el-tabs__item {
  font-size: 16px !important;
}
</style>